import { CSSProperties } from 'react';

import UIConfig from '@/UIConfig.ts';

export const containerStyle: CSSProperties = {
  width: '100%',
  position: 'fixed',
  bottom: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: 'white',
  borderTopLeftRadius: UIConfig.Card.Content.borderRadius,
  borderTopRightRadius: UIConfig.Card.Content.borderRadius,
  paddingBottom: '20px',
  overflowY: 'auto'
};

export const contentStyle: CSSProperties = {
  width: '100%'
};

export const headerStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: '10px 15px',
  position: 'relative'
};

export const titleStyle: CSSProperties = {
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
  fontSize: '18px',
  fontWeight: 'bold',
  textAlign: 'center'
};

export const closeButtonWrapperStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center'
};

export const contentContainerStyle: CSSProperties = {
  paddingLeft: '20px',
  paddingRight: '20px',
  paddingBottom: '10px'
};